export const multipliersMenuKayak = [
    {
        id: "extra_bid",
        label: "Extra Bid"
    },
    {
        id: "max_bid",
        label: "Max Bid"
    },
    {
        id: "market_bids",
        label: "Market Bids"
    },
    {
        id: "weekend_stay_multipliers",
        label: "Weekend Stay"
    },
    {
        id: "days_to_arrival_multipliers",
        label: "Days to arrival"
    },
    {
        id: "length_of_stay_multipliers",
        label: "Length Of Stay"
    }
];